export enum ROUTS {
  HOME_PAGE = "/",
  FORGOT_PASSWORD_PAGE = "/forgot-password",

  HOME_DASHBOARD = "/",

  ARCHIVE = "/archive",
  ARCHIVE_SALES_DASHBOARD = "/archive/sales",
  ARCHIVE_ORDERS_DASHBOARD = "/archive/orders",
  ARCHIVE_REFUNDS_DASHBOARD = "/archive/refunds",

  SUMUP_CLOSINGZREPORT_DASHBOARD = "/pos/closing-z-reports",
  SUMUP_HANDOVERRECORD_DASHBOARD = "/pos/handover-record",
  STORE_CASHIERDESKMANAGEMENT_DASHBOARD = "/pos/cashier-desk-management",
  SETTINGS_POS_CONFIGURATION_DASHBOARD = "/pos/pos-configuration",

  SUMUP_SALES_DASHBOARD = "/sum-up/sales",
  SUMUP_REFUNDS_DASHBOARD = "/sum-up/refunds",
  SUMUP_ENCASHMENT_DASHBOARD = "/sum-up/encashment",
  SUMUP_PAYMENTSUMMARY_DASHBOARD = "/sum-up/payment-summary",

  COMMODITY_PRODUCTS_DASHBOARD = "/commodity/products",
  COMMODITY_COMMODITYPACKAGE_DASHBOARD = "/commodity/commodity-package",
  COMMODITY_CATEGORIES_DASHBOARD = "/commodity/categories",

  WAREHOUSE_PRODUCTS_DASHBOARD = "/warehouse/products",

  STORE_STORES_DASHBOARD = "/store/stores",

  STAFF_DASHBOARD = "/staff",

  FILEEXPORT_DASHBOARD = "/file-export",

  SUPPORT_DASHBOARD = "/support",

  SETTINGS_DASHBOARD = "/settings",

  ORDERS_DASHBOARD = "/orders/orders",

  TRANSFER_CASHDESK_DASHBOARD = "/orders/transfer-pos",

  STATISTICS_DASHBOARD = "/statistics",
  STATISTICS_SALES_AMOUNT_DASHBOARD = "/statistics/sales-amount",
  STATISTICS_CHECKS_COUNT_DASHBOARD = "/statistics/checks-count",
  STATISTICS_AVERAGE_CHECK_DASHBOARD = "/statistics/average-check",
  STATISTICS_REFUNDS_AMOUNT_DASHBOARD = "/statistics/refunds-amount",
  STATISTICS_REFUNDS_COUNT_DASHBOARD = "/statistics/refunds-count",
  STATISTICS_PAYMENT_METHODS_DASHBOARD = "/statistics/payment-methods",
  STATISTICS_PAYMENT_TYPES_DASHBOARD = "/statistics/payment-types",
  STATISTICS_DAILY_DASHBOARD = "/statistics/daily-statistic",
  STATISTICS_EMPLOYEE_DASHBOARD = "/statistics/employee-statistic",
  STATISTICS_PRODUCT_DASHBOARD = "/statistics/product-statistic",
}
